import { faBell } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAllNotifications, markNotificationAsRead } from "../../Api";
import { RootState } from "../../Redux/Store/Store";
import lottieEmptyCart from "../../assets/lotties/emptyCart.json";
import { Player } from "@lottiefiles/react-lottie-player";
import NoDataFound from "../NoDataFound/NoDataFound";
import { Col, Row } from "react-bootstrap";
import { clickBellIcon } from "../../Api/apis/notificationsApi";

interface NotificationItem {
  id: number;
  message: string;
  created_at: string; // ISO date string
  is_read: boolean;
  read_at: any;
}

interface NotificationProps {
  notifications: NotificationItem[];
  loading: boolean;
}

const Notification: React.FC<NotificationProps> = ({ notifications, loading }) => {

  const [showNotification, setShowNotification] = useState<boolean>(false);
  const navigate = useNavigate();
  const role = useSelector((state: RootState) => state.User.ActiveRole); // Get the active role from Redux state
  const [notificationsList, setNotificationsList] = useState<NotificationItem[]>([]);
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [loadings, setLoadings] = useState<boolean>(false);

  // Determine the parameters based on role
  const getNotificationParams = () => {
    if (role === "user") {
      return {
        // unread: true,
        storeNotification: false,
        userNotification: true,
      };
    } else if (role === "store") {
      return {
        // unread: true,
        storeNotification: true,
        userNotification: false,
      };
    }
    // Default case in case role is undefined
    return {
      unread: true,
      storeNotification: false,
      userNotification: true,
    };
  };
  // Fetch only unread notification count
  const fetchUnreadCount = async () => {
    try {
      const params = { ...getNotificationParams(), unread: true };
      const data = await getAllNotifications(params);
      // setUnreadCount(data.results?.length || 0);
      setUnreadCount(data.unread_notifications_count || 0);
    } catch (err) {
      console.error("Error fetching count:", err);
    }
  };


  // Fetch notifications
  const fetchNotifications = async () => {
    setLoadings(true);
    try {
      const params = getNotificationParams();
      const data = await getAllNotifications(params);
      setNotificationsList(data.results || []);
      // setUnreadCount(data.results?.filter((n: NotificationItem) => !n.is_read).length || 0);
      // setUnreadCount(data.results?.filter((n: any) => n.read_at === null).length || 0);
      setUnreadCount(data.unread_notifications_count || 0);
    } catch (err) {
      console.error("Error fetching notifications:", err);
    } finally {
      setLoadings(false);
    }
  };


  const seenNotification = async () => {
    try {
      const data = await clickBellIcon();

    } catch (err) {
      console.log(err);
    }
  }

  // Fetch unread count when the component mounts
  useEffect(() => {
    fetchUnreadCount();
  }, [role]);


  const handleNotificationClick = async (notificationId: number) => {
    try {
      await markNotificationAsRead(notificationId);
      setNotificationsList((prev) =>
        // prev.map((note) => (note.id === notificationId ? { ...note, is_read: true } : note))
        prev.map((note) => (note.id === notificationId ? { ...note, read_at: new Date().toISOString() } : note))
      );
      setUnreadCount((prev) => Math.max(0, prev - 1)); // Decrease unread count dynamically
    } catch (err) {
      console.error("Error marking notification as read:", err);
    }
  };
  return (
    <div
      className="notification-container"
      onClick={() => {
        if (showNotification === false) {
          seenNotification();
          fetchNotifications();
        }
        // setShowNotification(true);
      }}
      onMouseLeave={() => setShowNotification(false)}
      style={{ position: "relative", cursor: "pointer" }}
    >
      {/* Bell Icon */}
      <div onClick={()=>{setShowNotification(!showNotification)}}>
      <FontAwesomeIcon icon={faBell} size="lg" />
      </div>
      {/* Notification Count Badge */}
      {unreadCount > 0 && (
        <div
        onClick={()=>{setShowNotification(true)}}
          style={{
            color: "white",
            position: "absolute",
            right: -15,
            top: -15,
            width: "1.5rem",
            height: "1.3rem",
            borderRadius: "50%",
            backgroundColor: "red",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "small",
            fontWeight: "bold",
          }}
        >
          {unreadCount}{unreadCount > 99 ? "+" : ""}
        </div>
      )}

      {/* Notification Dropdown */}
      {showNotification && (
        <div className="notification-dropdown">
          {/* Title with Blue Background */}
          <div className="notification-heading">Notifications</div>

          <div
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              padding: "0rem",
            }}
          >

            {loading && !notificationsList && (
              <Row>
                <Col className="d-flex align-items-center justify-content-center">
                  <Player
                    src={lottieEmptyCart}
                    loop
                    autoplay
                    className="player"
                    style={{ height: "100px", width: "100px" }}
                  />
                </Col>
              </Row>
            )}
            {loading ? (
              <p>Loading...</p>
            ) : notificationsList.length === 0 ? (
              <div className="text-center">
                <NoDataFound title="No New Notification" />
              </div>
            ) : (
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {notificationsList.map((note) => (
                  <li
                    key={note.id}
                    className="notification-item"
                    onClick={() => handleNotificationClick(note.id)} // Handle the click to mark as read
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0.8rem",
                      borderBottom: note.read_at !== null ? "2px solid #e0eefe" : "2px solid #fff",
                      backgroundColor: note.read_at !== null ? "#fff" : "#e0eefe",
                    }}
                  >
                    <div
                      style={{
                        minWidth: "2.5rem",
                        width: "2.5rem",
                        height: "2.5rem",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: note.read_at !== null ? "#e0eefe" : "#fff",
                        borderRadius: "50%",
                        marginRight: "1rem",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faBell}
                        size="lg"
                        style={{ color: "#007bff" }}
                      />
                    </div>

                    {/* Message and Timing */}
                    <div style={{ flexGrow: 1 }}>
                      <p
                        style={{
                          margin: 0,
                          fontWeight: note.read_at !== null ? "medium" : "bold",
                        }}
                      >
                        {note.message}
                      </p>
                      <span className="ago">{moment(note.created_at).fromNow()}</span>
                    </div>

                    {/* Green Dot for Unread */}
                    {!(note.read_at !== null) && (
                      <span
                        style={{
                          minWidth: "0.6rem",
                          width: "0.6rem",
                          height: "0.6rem",
                          borderRadius: "100%",
                          backgroundColor: "var(--primary-color)",
                          marginLeft: "0.5rem",
                        }}
                      ></span>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* View All Notifications Link */}
          <div
            style={{
              textAlign: "center",
              padding: "0.8rem",
              borderTop: "1px solid #f0f0f0",
            }}
          >
            <button
              onClick={() => navigate("/notifications")}
              style={{
                background: "none",
                border: "none",
                color: "#007bff",
                cursor: "pointer",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              View All Notifications
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notification;
